/**
 * Zod schemas dla AI generation endpoints.
 *
 * Backend (apps/api Hono routes) uzywa do walidacji request body.
 * Frontend (apps/web hooks) uzywa do typesafe form build + assert response.
 */
import { z } from "zod";

export const StartProcessingRequestSchema = z.object({
  variantType: z.string().min(1).max(64),
  sourceImage: z.string().startsWith("data:image/", "sourceImage must be a data URL"),
  parameters: z.record(z.unknown()).optional(),
});

export type StartProcessingRequestParsed = z.infer<typeof StartProcessingRequestSchema>;

/** Synchroniczna odpowiedź generatora (parytet v1) — resultImage inline. */
export const StartProcessingResponseSchema = z.object({
  jobId: z.string(),
  resultImage: z.string(),
  purchased: z.boolean(),
  cost: z.number(),
});

export type StartProcessingResponseParsed = z.infer<typeof StartProcessingResponseSchema>;
